/**
 * Create a basic component with common options
 */
console.log('before import locale create-basic')
import '../locale';
import bem from '../mixins/bem';
import i18n from '../mixins/i18n';

const install = function(Vue) {
  Vue.component(this.name, this);
};

export default function(sfc) {
  sfc.name = 'om-' + sfc.name;
  sfc.install = sfc.install || install;
  sfc.mixins = sfc.mixins || [];
  sfc.mixins.push(i18n, bem);

  return sfc;
};



// WEBPACK FOOTER //
// ./src/plugins/jscom/omui/components/utils/create-basic.js